import { db } from "../Config";

const getDeviceInfo = () => {
  if (typeof window === "undefined" || !window.navigator) {
    return { platform: "", userAgent: "", language: "" };
  }
  return {
    platform: window.navigator.platform || "",
    userAgent: window.navigator.userAgent || "",
    language: window.navigator.language || "",
  };
};

export const saveProspecto = async (email, data = {}) => {
  if (!email) return null;
  try {
    const docRef = db.collection("prospectos").doc(email);
    const existing = await docRef.get();
    const now = new Date();
    const existingData = existing.exists ? existing.data() : {};

    // 1. Datos básicos normalizados
    const nombres = data.nombres || existingData.nombres || "";
    const correo = email || data.email || existingData.email || "";
    const telefono = data.telefono || existingData.telefono || "";
    const telefonoVerificado = typeof data.telefonoVerificado === "boolean" ? data.telefonoVerificado : (existingData.telefonoVerificado || false);
    const fechaVerificacionTelefono = data.fechaVerificacionTelefono || existingData.fechaVerificacionTelefono || null;
    const cop = data.cop || existingData.cop || "";
    const uid = data.uid || existingData.uid || "";

    // 2. Bloque canónico userInfo (compatibilidad con www-sysdent-net y adm_sysdent_v1)
    const userInfo = {
      nombres,
      correo,
      telefono,
      telefonoVerificado,
      fechaVerificacionTelefono,
      cop,
      ...(existingData.userInfo || {}),
      ...(data.userInfo || {}),
    };

    // 3. Mapeo estructurado de answers (cuestionario diagnóstico homologado)
    const tipoEstablecimiento = data.tipoEstablecimiento || existingData.tipoEstablecimiento || "independiente";
    const rolUsuario = data.rolUsuario || existingData.rolUsuario || "ODONTOLOGO_DUENO";
    const numDoctores = data.numDoctores || existingData.numDoctores || "1";
    const volumenPacientes = data.volumenPacientes || existingData.volumenPacientes || "less_50";
    const gestionActual = data.gestionActual || existingData.gestionActual || "papel";

    const answers = {
      question1: tipoEstablecimiento === "clinica" ? "clinica_varios" : "consultorio_pequeno",
      question2: rolUsuario,
      tipoEstablecimiento,
      rolUsuario,
      numDoctores,
      volumenPacientes,
      gestionActual,
      ...(existingData.answers || {}),
      ...(data.answers || {}),
    };

    // 4. Metadatos de dispositivo
    const device = data.device || existingData.device || getDeviceInfo();

    // 5. Payload completo enriquecido y homologado
    const payload = {
      origen: "app_registro",
      email: correo,
      nombres,
      telefono,
      cop,
      uid,
      razonSocial: data.razonSocial || existingData.razonSocial || "",
      tipoEstablecimiento,
      rolUsuario,
      numDoctores,
      volumenPacientes,
      gestionActual,
      planRecomendado: data.planRecomendado || existingData.planRecomendado || "",
      planSeleccionado: data.planSeleccionado || existingData.planSeleccionado || "",
      empresaId: data.empresaId || existingData.empresaId || "",
      pasoActual: typeof data.pasoActual === "number" ? data.pasoActual : (existingData.pasoActual || 1),
      pasoLabel: data.pasoLabel || existingData.pasoLabel || "Inicio",
      estado: data.estado || existingData.estado || "en_progreso",
      status: data.status || existingData.status || (data.estado === "completado" ? "Completado" : "Nuevo"),
      userInfo,
      answers,
      device,
      fechaActualizacion: now,
      ...data,
    };

    if (!existing.exists) {
      payload.fechaRegistro = now;
      payload.createdAt = now;
      payload.estado = payload.estado || "en_progreso";
      payload.status = payload.status || "Nuevo";
    }

    await docRef.set(payload, { merge: true });
    return docRef.id;
  } catch (err) {
    console.error("Error al guardar prospecto:", err);
    return null;
  }
};
